<template>
  <div class="statusLabel">
    <div
      class="status"
      :class="{ off: status === 3|| status === 4, stop: status === 2 }"
    >
      {{ statusText }}
    </div>
    <img v-if="status === 2" class="error" src="/static/img/choundiary/error.svg" />
  </div>
</template>

<script>
export default {
  name: 'PaymentStatus',
  props: {
    status: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  computed: {
    statusText() {
      switch (this.status) {
        case 1:
          return '利用中'
        case 2:
          return '停止中'
        case 3:
          return '解約予定'
        case 4:
          return '解約済'
        default:
          return ''
      }
    },
  },
  methods: {},
}</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";
.statusLabel {
  display: flex;
  .status {
    font-weight: bold;
    font-size: 11px;
    line-height: 16px;
    color: $diary_orange;
    border: 1px solid $diary_orange;
    border-radius: 10px;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 3px;
    width: 80px;
    text-align: center;
    &.off {
      color: $col_gray2;
      border: 1px solid $col_gray2;
    }
    &.stop {
      background: $diary_yellow;
    }
  }
  .error {
    margin-left: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/partials/StatusLabel.vue